import React from 'react';

import { INotificationProps, NOTIF_TYPES } from '@private/notifications';

import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';

import {
  BackCircularProgress,
  CloseButton,
  Container,
  Content,
  FrontCircularProgress,
  IconContainer,
  LoaderBox,
  Message,
  Row,
  Title,
} from './styled';

const Notification = ({
  className,
  icon,
  message = '',
  onClose,
  title = '',
  type = NOTIF_TYPES.INFO,
}: INotificationProps) => {
  const renderIcon = () => {
    if (icon) {
      return <IconContainer>{icon}</IconContainer>;
    }

    switch (type) {
      case NOTIF_TYPES.ERROR:
        return <ICONS_MAP.NotificationError />;
      case NOTIF_TYPES.INFO:
        return <ICONS_MAP.NotificationInfo />;
      case NOTIF_TYPES.LOADING:
        return (
          <IconContainer>
            <LoaderBox>
              <BackCircularProgress lineWidth={4} />
              <FrontCircularProgress lineWidth={4} />
            </LoaderBox>
          </IconContainer>
        );
      case NOTIF_TYPES.SUCCESS:
        return <ICONS_MAP.NotificationSuccess />;
      case NOTIF_TYPES.WARNING:
        return <ICONS_MAP.NotificationWarning />;
      default:
        return <IconContainer />;
    }
  };

  return (
    <Container className={className as string} data-testid='notification' type={type}>
      <Row>
        <IconContainer $ntfType={type}>{renderIcon()}</IconContainer>
        <Content>
          <Title data-testid='notificationTitle'>{title}</Title>
          {!!message && (
            <Message data-testid='notificationMessage' size='xs' variant='regular'>
              {message}
            </Message>
          )}
        </Content>
        <CloseButton
          iconSize={10}
          onClick={onClose}
          startIcon={<ICONS_MAP.Close />}
          testIds={{ container: 'notificationCloseButton' }}
          variant='icon'
        />
      </Row>
    </Container>
  );
};

export default appReactMemo(Notification);
